export const enum ReturnsGenericEvents {
	RETURN_DROPPOINT = 'return_droppoint',
	RETURN_HOME_PICKUP = 'return_home',
	RETURN_STORE = 'return_store',
}
